import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from "@angular/core";
import {PocketbaseService} from "../services/pocketbase.service";

export const canActivate: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const pocketbase = inject(PocketbaseService);
  const router = inject(Router);

  if(pocketbase.pb.authStore.isValid){
    return true;
  }
  router.navigate(["/login"])
  return false;
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);
